// src/plugins/topToast.js
import Vue from "vue";
import TopToastHost from "@/components/TopToastHost.vue";

let hostVm = null;

function ensureHost() {
  if (hostVm) return hostVm;

  const HostCtor = Vue.extend(TopToastHost);
  hostVm = new HostCtor();
  hostVm.$mount(document.createElement("div"));
  document.body.appendChild(hostVm.$el);
  return hostVm;
}

function normalize(input, type) {
  // 支持：this.$toast("xxx") 或 this.$toast({title,desc,type})
  if (typeof input === "string") {
    return { type: type || "info", title: input, desc: "", duration: 2600 };
  }
  const p = input || {};
  return {
    type: p.type || type || "info",
    title: p.title || "",
    desc: p.desc || "",
    duration: Number(p.duration || 2600),
  };
}

const api = {
  show(payload) {
    const host = ensureHost();
    return host.push(normalize(payload, "info"));
  },
  success(payload) {
    const host = ensureHost();
    return host.push(normalize(payload, "success"));
  },
  warn(payload) {
    const host = ensureHost();
    return host.push(normalize(payload, "warn"));
  },
  error(payload) {
    const host = ensureHost();
    return host.push(normalize(payload, "error"));
  },
  clear() {
    const host = ensureHost();
    host.clear();
  },
};

export default {
  install(Vue) {
    Vue.prototype.$toast = api;
  },
};

export { api as topToast };
